// extracted by mini-css-extract-plugin
export default {"imageWrapper":"ZM-z","twoColumnImage":"_M-z"};